import fixed from './fixed';

export default {
  fixed,
};
